/**
 * Single source of truth for the company details printed on the shipping
 * label and the invoice. Edit here — both print pages read from this file.
 */
const company = {
  /** Shown next to the logo and used as the document owner name. */
  name: "پارسیان ال ای دی",
  latinName: "Parsian LED",
  /** Path under /public. Swap for the real logo file. */
  logo: "/img/logo.png",
  /** Sender address printed on the label. */
  address:
    "استان تهران، شهر تهران، ميدان امام خميني، خيابان لاله زار، کوچه مجمر، پلاک 26",
  postalCode: "1144936141",
  phoneNumbers: ["02191305060", "09128802386"],
  /** Sender phone printed on the shipping label. */
  labelPhone: "09105734145",
  /** Printed under the logo on the shipping label. */
  labelTitle: "فروشگاه پارسیان LED",
  /** Prefix for the printed invoice number, e.g. PL-10023. Leave empty to hide. */
  invoicePrefix: "",
  /** Currency label printed next to prices. */
  currency: "تومان",
};

export default company;
